import { useToast } from '@chakra-ui/react';
import { useEffect } from 'react';
import { StyledToast } from '../views/components/StyledToast';
import { usePhoton } from '@photonhealth/react';

export function useWelcomeToast() {
  const { user } = usePhoton();
  const toast = useToast();

  useEffect(() => {
    const welcomeUser = () => {
      const isInitialLogin = localStorage.getItem('selfSignupInitialLogin') === 'true';

      if (user && isInitialLogin) {
        toast({
          position: 'top',
          duration: 5_000,
          containerStyle: {
            // for full width on mobile
            width: { base: '95%', md: 'auto' },
            maxWidth: { base: '95%', md: '24rem' }
          },
          render: ({ onClose }) => (
            <StyledToast
              onClose={onClose}
              type="success"
              title={`Welcome ${user.given_name}!`}
              description="Add a patient to get started"
            />
          )
        });
      }

      localStorage.removeItem('selfSignupInitialLogin');
    };

    const welcomeTimeout = setTimeout(welcomeUser, 10_000);
    return () => clearTimeout(welcomeTimeout);
  }, [toast, user]);
}
